import theme from "@/stylesheets/theme.module.scss";
import i18n from "@entrypoints/i18n.ts";

const t = i18n.getFixedT(null, "user");

// eslint-disable-next-line no-shadow
export enum CompletionStatus {
  Complete = "complete",
  AlmostFinished = "almost_finished",
  InProgress = "in_progress",
  NotStarted = "not_started",
}

// eslint-disable-next-line no-shadow
export enum IdentityVerificationStatus {
  Success = "success",
  Fail = "fail",
  AwaitingUserInput = "awaiting_user_input",
  ProcessingData = "processing_data",
  Expired = "expired",
  Canceled = "canceled",
}

export type CompletionStatusType = `${CompletionStatus}`;
export type IdentityVerificationStatusType = `${IdentityVerificationStatus}`;
export type TaskStatusType = CompletionStatusType | IdentityVerificationStatusType;

export const statusInfo = (status: CompletionStatusType) => {
  if (status === CompletionStatus.Complete) {
    return { label: t("progress.complete"), color: theme.greenE100 };
  } else if (status === CompletionStatus.AlmostFinished) {
    return { label: t("progress.almostFinished"), color: theme.irisE50 };
  } else if (status === CompletionStatus.InProgress) {
    return { label: t("progress.inProgress"), color: theme.yellowE25 };
  } else {
    return { label: t("progress.notStarted"), color: theme.smokeGray };
  }
};
